module.exports = __webpack_public_path__ + "img/images06.06f09c11.jpg";